import { registerIconLibrary } from "https://early.webawesome.com/webawesome@3.0.0-alpha.13/dist/webawesome.loader.js";

registerIconLibrary('kit', {
  resolver: name => `/custom-icons.svg#${name}`,
  spriteSheet: true
});
